import { withReportScope } from '@/application/metrics/metricsScope';

/** Alcance que los crumbs superiores deben conservar al subir de nivel. */
export interface BreadcrumbScope {
  period?: string;
  tenantId?: string | null;
}

/**
 * Href de un nivel superior: mergea `period` y `tenant` (si aplica) sin pisar el resto de la query.
 * `tenant=all` no se propaga: la casa de dominio vuelve a vista de red.
 */
export function breadcrumbHref(path: string, scope: BreadcrumbScope = {}): string {
  const tenantId = scope.tenantId && scope.tenantId !== 'all' ? scope.tenantId : undefined;
  return withReportScope(path, {
    period: scope.period,
    tenantId,
  });
}
